export default __webpack_public_path__ + "assets/logo_drive_2020q4_color_2x_web_64dp.png";